const ROTATE = {
    clear: {
        title: `Remove Your Image`,
        description: ``,
        question: `Are you sure you would like to remove your image?`,
        actionButton: `Remove`
    }
}

const RESIZE = {
    clear: {
        title: `Remove Your Image`,
        description: `Remove the image will remove all the resized images and any edits you\`ve made to them.`,
        question: `Are you sure you would like to remove your image?`,
        actionButton: `Remove`
    }
}

export default function getContantPage(service) {
    switch (service) {
        case 'rotator':
        case 'flipper':
        case 'cropper':
            return ROTATE;

        case 'resizer':
            return RESIZE;
    }

}